/* !
 * news.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';
	const _pagepath = '/news/';
	const _pagepath_en = '/eng/news/';
	const _pagepath_cn = '/cn/news/';
	const dropDown = () => {
	    if(document.querySelector('.js-news-yearList')) {
	        // 最新と最古の年を取得
	        const latest = document.querySelector('.js-news-latest-year').textContent;
	        const earliest = document.querySelector('.js-news-earliest-year').textContent;
	        // ドロップダウンリスト要素を取得
	        const yearList = document.querySelector('.js-news-yearList');
	        const optionVal = (_num) => {
	            let basePath = _pagepath;
	            if (location.pathname.includes('/eng/')) {
	                basePath = _pagepath_en;
	            } else if (location.pathname.includes('/cn/')) {
	                basePath = _pagepath_cn;
	            }

	            if(location.pathname.replace('index.html','') === basePath) {
	                return basePath + _num + `/`;
	            } else {
	                if(location.pathname.match(/\d{4}/)){
	                    // 文字列に正規表現4桁数値が含まれていたら
	                    return location.pathname.replace(location.pathname.match(/\d{4}/)[0], _num);
	                }
	            }
	        };
	        // 最新から最古の年までのオプションを生成し追加
	        for(let i = latest; i >= earliest; i--) {
	            const option = document.createElement('option');
	            option.textContent = i.toString();
	            option.value = optionVal(i);
	            yearList.appendChild(option);
	        }
	        // ドロップダウンリストで選択された年を設定
	        yearList.value = location.pathname;
	        
	        // ドロップダウンリストの変更イベントを処理(プルダウンの場合)
	        yearList.addEventListener('change', function() {
	            location.href = yearList.value;
	        });
	    }
	};
	dropDown();


})(window.FUNCTIONS);